import React from 'react';
import { useLocation } from 'react-router-dom';
import NovaWidget from './index';

const AUTH_PATHS = [
  '/', '/sign-up', '/forget-password', '/otp-verification',
  '/audit-portal/login', '/audit-portal/forgot-password', '/audit-portal/reset-password',
  '/audit-portal/signup', '/audit-portal/register',
];

export default function NovaMount() {
    const { pathname } = useLocation();
    if (AUTH_PATHS.includes(pathname)) return null;
    return sessionStorage.getItem('access_token') ? <NovaWidget /> : null;
}
